module.exports = __webpack_public_path__ + "static/media/Heks.7eab3326.PNG";